import { render, staticRenderFns } from "./accessRecords.vue?vue&type=template&id=3408baca&scoped=true"
import script from "./accessRecords.vue?vue&type=script&lang=js"
export * from "./accessRecords.vue?vue&type=script&lang=js"
import style0 from "./accessRecords.vue?vue&type=style&index=0&id=3408baca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3408baca",
  null
  
)

export default component.exports